import React from "react";
import { Avatar } from "antd";
import styles from "./ContactItem.module.scss";
import { getAvatarText } from "../../utils";
import { Contact } from "../../types/contact";

interface ContactItemProps {
  contact: Contact;
  onClick?: (contact: Contact) => void;
}

const ContactItem: React.FC<ContactItemProps> = ({ contact, onClick }) => {
  return (
    <div className={styles.contactItem} onClick={() => onClick?.(contact)}>
      <div className={styles.avatarWrapper}>
        <Avatar size={48} src={contact.AvatarUrl} className={styles.avatar}>
          {!contact.AvatarUrl && getAvatarText(contact.ContactName)}
        </Avatar>
      </div>
      <div className={styles.contactInfo}>
        <div className={styles.contactName}>{contact.ContactName}</div>
        <div className={styles.contactDetails}>{contact.Description && <span>{contact.Description}</span>}</div>
      </div>
    </div>
  );
};

export default React.memo(ContactItem);
